import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const InfoIconWrapper = styled.div`
  display: flex;

  svg {
    width: 22px;
    height: 22px;
  }
`

export const PromoCodeTitle = styled.div`
  color: ${myPalette.midnightBlue.main};
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
`

export const PromoCodeDescription = styled.div`
  font-size: 16px;
  font-weight: 400;
`
